import { faWandMagicSparkles } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, Loading } from '@wfp/react';
import type { FC } from 'react';
import React from 'react';

interface Props {
  label: string;
  isLoading: boolean;
  disabled: boolean;
  testId: string;
  onClick: () => void;
}

const AiActionButton: FC<Props> = ({
  label,
  isLoading,
  disabled,
  testId,
  onClick,
}) => (
  <Button
    onClick={onClick}
    kind="ghost"
    className="ai-action-button"
    disabled={disabled || isLoading}
    data-test-id={testId}
  >
    {isLoading ? (
      <Loading className="wfp--loading--small" withOverlay={false} active />
    ) : (
      <FontAwesomeIcon icon={faWandMagicSparkles} aria-hidden="true" />
    )}
    {label}
  </Button>
);

export default AiActionButton;
